<div class="row row-sm add-form">
    <form autocomplete="off" class="p-0" novalidate [formGroup]="SessionForm ">
        <div class="col-lg-12 col-md-12"> 
                <div class="card-body"> 

                    <!-- <div *ngIf="submitButton">
                        <h3 class="main-content-label mb-1">
                            <b>{{'header.session-data.titleList.AddNewRecord'| translate}}</b>
                        </h3>
                        <p class="text-muted card-sub-title mb-0">
                            {{'header.session-data.titleList.AddNewInfo'| translate}}</p>
                    </div>
                    <div *ngIf="editButton">
                        <h3 class="main-content-label mb-1">
                            <b>{{'header.session-data.titleList.UpdateRecord'| translate}}</b>
                        </h3>
                        <p class="text-muted card-sub-title mb-0">
                            {{'header.session-data.titleList.UpdateSelectedInfo'| translate}}</p>
                    </div> -->
                    <div class="bc d-flex align-items-center pl-3" *ngIf="submitButton">
                        <img alt="Logo" src="../../assets/img/clock.png" class="mh-40px pb-2">
                        <div class="ml-2">
                          <h3 class="main-content-label mb-1"><b>
                            {{'header.session-data.titleList.AddNewRecord'| translate}}
                          </b></h3>
                          <p class="text-muted card-sub-title mb-0">
                            {{'header.session-data.titleList.AddNewInfo'| translate}}
                          </p>
                        </div>
                      </div>
                      <div class="bc d-flex align-items-center pl-3" *ngIf="editButton">
                        <img alt="Logo" src="../../assets/img/clock.png" class="mh-40px pb-2">
                        <div class="ml-2">
                          <h3 class="main-content-label mb-1"><b>
                            {{'header.session-data.titleList.UpdateRecord'| translate}}
                          </b></h3>
                          <p class="text-muted card-sub-title mb-0">
                            {{'header.session-data.titleList.UpdateSelectedInfo'| translate}}
                          </p>
                        </div>
                      </div>
                   
                    <hr> 
                    <div class="row clearfix mt-3">

                        <div class="col-sm-3">
                            <div class="form-group">
                                <div class="">
                                    <mat-form-field appearance="outline" class="example-full-width" >
                                        <mat-label>{{'header.session-data.titleList.SessionYear'|
                                            translate}}</mat-label>
                                        <input [readonly]="isreadonly" class="color" onkeydown="return (event.keyCode!=13);"
                                            matInput formControlName="SnYear" placeholder="Session Year" required maxlength="4"
                                            min="1800" (change)="sessionName2()">
                                            <mat-error class="margin_tp"
                                                *ngIf="SessionForm.controls['SnYear'].touched && SessionForm.controls['SnYear'].errors?.required">
                                               Mandatory
                                            </mat-error>
                                            <mat-error class="margin_tp"
                                                *ngIf="SessionForm.controls['SnYear'].touched && SessionForm.controls['SnYear'].errors?.pattern">
                                                Invalid
                                            </mat-error>
                                            <mat-error class="margin_tp"
                                                *ngIf="SessionForm.controls['SnYear'].touched && SessionForm.controls['SnYear'].errors?.min">
                                                Enter Year Between 1800 to 2100
                                            </mat-error>
                                            <mat-error class="margin_tp"
                                                *ngIf="SessionForm.controls['SnYear'].touched && SessionForm.controls['SnYear'].errors?.max">
                                                Enter Year Between 1800 to 2100
                                            </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <div class="">
                                    <mat-form-field appearance="outline" class="example-full-width"  >
                                        <mat-label>{{'header.session-data.titleList.SessionCode'|
                                            translate}}</mat-label>
                                        <mat-select class="color" [disabled]="isreadonly" onkeydown="return (event.keyCode!=13);"
                                            #select55 class="colorblack" formControlName="SnCode" required>
                                            <mat-select-filter *ngIf="select55.focused" [placeholder]="'Filter'"
                                                [displayMember]="'CdDesc'" [array]="codeTypeList"
                                                (filteredReturn)="filteredCodeType =$event">
                                            </mat-select-filter>
                                            <mat-option *ngFor="let item of filteredCodeType" [value]="item.CdCode"
                                                (click)="sessionName(item.CdDesc);">
                                                {{item.CdDesc}}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error class="margin_tp"
                                            *ngIf="SessionForm.controls['SnCode'].touched && SessionForm.controls['SnCode'].errors?.required">
                                           Mandatory
                                        </mat-error>
                                        <mat-error class="margin_tp"
                                            *ngIf="SessionForm.controls['SnCode'].touched && SessionForm.controls['SnCode'].errors?.pattern">
                                            Invalid
                                        </mat-error>

                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <div class="">
                                    <mat-form-field appearance="outline" class="example-full-width" >

                                        <mat-label>Session Name</mat-label>
                                        <input readonly class="color" onkeydown="return (event.keyCode!=13);" matInput
                                            formControlName="SnName" placeholder="Session Name" maxlength="50">
                                            <mat-error class="margin_tp"
                                                *ngIf="SessionForm.controls['SnName'].touched && SessionForm.controls['SnName'].errors?.required">
                                               Mandatory
                                            </mat-error>
                                            <mat-error class="margin_tp"
                                                *ngIf="SessionForm.controls['SnName'].touched && SessionForm.controls['SnName'].errors?.pattern">
                                                Invalid
                                            </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <div class="">
                                    <div class="row ">
                                        <div class="col-sm-4 mt-3">
                                            <mat-label class="mt-1 lclass "><span
                                                    class="required-asterisk mr-1"></span>{{'header.session-data.titleList.SessionDefault'|
                                                translate}}</mat-label>
                                        </div>
                                        <div class="col-sm-6 mt-3">
                                            <mat-radio-group onkeydown="return (event.keyCode!=13);" formControlName="SnDefault"
                                                class="example-full-width" >
                                                <div class="row">
                                                    <div class="col-sm-6">
                                                        <mat-radio-button value="Y">Yes
                                                        </mat-radio-button>
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <mat-radio-button value="N">No
                                                        </mat-radio-button>
                                                    </div>

                                                </div>
                                            </mat-radio-group>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="form-group">
                                <div class="">
                                    <div class="row">
                                        <div class="col-sm-4 mt-3">
                                            <mat-label class="mt-1 lclass"><span
                                                    class="required-asterisk mr-1"></span>{{'header.session-data.titleList.SessionStatus'|
                                                translate}}</mat-label>
                                        </div>
                                        <div class="col-sm-6 mt-3">
                                            <mat-radio-group onkeydown="return (event.keyCode!=13);" formControlName="SnStatus"
                                                class="example-full-width" >
                                                <div class="row">
                                                    <div class="col-sm-6">
                                                        <mat-radio-button value="O">Open
                                                        </mat-radio-button>
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <mat-radio-button value="C">Close
                                                        </mat-radio-button>
                                                    </div>
                                                </div>
                                            </mat-radio-group>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="col-sm-12 align-right">
                            <button type="button"
                                class="btn btn-primary my-2 me-2  btn-icon-text floatright btn btn-raised g-bg-blush2"
                                *ngIf="submitButton  && sessCreate" (click)="submit()">
                                    {{'header.session-data.titleList.Submit'| translate}}
                            </button>
                            <button type="button"
                                class="btn btn-primary my-2 me-2  btn-icon-text floatright   btn-raised g-bg-blush2"
                                *ngIf="editButton && sessUpdate" (click)="update()">
                                    {{'header.session-data.titleList.Update'| translate}}
                            </button>
                            
                            <button type="button" 
                                class="mat-focus-indicator mat-menu-trigger btn btn-white btn-icon-text my-2 me-2 floatright mat-button mat-button-base"
                                (click)="addnewrecord('false')">
                                    {{'header.session-data.titleList.Back'| translate}}
                            </button>
                        </div> -->
                        <div class="row col-sm-12"> 
                            <div class="col-sm-12 prpl ">
                                <button type="button" *ngIf="editButton && sessUpdate"
                                class="btn btn-primary btn-icon-text floatright mt-1 fr"
                                 (click)="update()">
                                <span style="display: contents; align-items: center;">
                                     <img width="20vh" src="../../assets/img/edit1.gif" style="margin-right: 5px;">
                                      Update
                                </span>
                                </button>
                                <button type="button" *ngIf="submitButton  && sessCreate"
                                class="btn btn-primary btn-icon-text floatright mt-1 fr"
                                 (click)="submit()">
                                <span style="display: contents; align-items: center;">
                                     <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                                     Save
                                </span> 
                                </button>
                                <button type="button" [mat-dialog-close]="true"
                                class="btn btn-primary btn-icon-text floatright mt-1 mr-3 fr">
                                <span style="display: contents; align-items: center;" >
                                     <img width="20vh" src="../../assets/img/turn-left.gif" style="margin-right: 7px;">
                                     Back
                                </span>
                                </button> 
                            </div>
                           
                        </div>
                    </div>
                </div>
       
        </div>
    </form>
</div>